













































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import DataSetService from '../../../services/dataset.service';
import moment from 'moment';
import Table from '@/components/Table.vue';
import ActionBarButton from '@/components/ActionBarButton.vue';
import ExportDialog from '@/components/ExportDialog.vue';
import {Getter} from 'vuex-class';
@Component({
  components: {ExportDialog, ActionBarButton, Table},
})
export default class QueryTabularResults extends Vue {
  @Getter private hasPermission: any;
  @Prop() private datasetUuid!: string;
  @Prop() private tableHeight!: string;
  private headers: any[] = [];
  private items: any[] = [];
  private readonly itemsPerPage: number = 50;
  private readonly defaultTotalItems: number = 0;
  private totalItems: number = this.defaultTotalItems;
  private loading: boolean = false;
  private skip: number = 0;
  private defaultOptions = {
    page: 1,
    itemsPerPage: this.itemsPerPage,
  };
  private options: any = {... this.defaultOptions };
  private initialOptions: any = {... this.defaultOptions };
  private page: number = 1;

  private showDateRangeModal: boolean = false;
  private selectedDateRange: string[] = [];
  private sinceBefore: Date[] = [];
  private csvDialog: boolean = false;
  private csvData: any = {};
  private columns: string[] = [];
  private init: boolean = true;

  private includeStock: boolean = true;
  private includeTestBench: boolean = true;

  private async mounted() {
    this.init = true;
    await this.reset();
    this.init = false;
  }

  @Watch('datasetUuid')
  private async onDatasetUuidChanged() {
    if (!this.init) {
      await this.reset();
    }
  }

  private async reset() {
    this.headers = [];
    this.sinceBefore = [];
    this.selectedDateRange = [];
    this.page = 1;
    this.skip = 0;
    this.initialOptions = {... this.defaultOptions };
    this.options = {... this.defaultOptions };
    this.totalItems = this.defaultTotalItems;
    await this.loadDataset();
  }

  private changeDateRange() {
    if (!this.selectedDateRange.length) {
      this.sinceBefore = [];
    } else if (this.selectedDateRange.length === 1) {
      this.sinceBefore = [new Date(this.selectedDateRange[0])];
    } else {
      let sinceDate = new Date(this.selectedDateRange[0]);
      let beforeDate = new Date(this.selectedDateRange[1]);
      if (sinceDate > beforeDate) {
        const tempDate = beforeDate;
        beforeDate = sinceDate;
        sinceDate = tempDate;
        const tempString = this.selectedDateRange[0];
        this.selectedDateRange[0] = this.selectedDateRange[1];
        this.selectedDateRange[1] = tempString;
      }
      this.sinceBefore = [sinceDate, beforeDate];
    }
    this.showDateRangeModal = false;
  }

  private set dateRangeText(value) {
    this.sinceBefore = [];
    this.selectedDateRange = [];
  }

  private get dateRangeText() {
    if (!this.selectedDateRange.length) {
      return '';
    } else if (this.selectedDateRange.length === 1) {
      return 'Since: ' + moment(this.selectedDateRange[0]).format('DD MMM YYYY');
    } else {
      const since = moment(this.selectedDateRange[0]).format('DD MMM YYYY');
      const before = moment(this.selectedDateRange[1]).format('DD MMM YYYY');
      return `Since: ${since} and Before: ${before}`;
    }
  }

  @Watch('sinceBefore', {deep: true})
  private async onSinceBeforeChanged(newVal: Date[], oldVal: Date[]) {
    if (!this.init) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.totalItems = this.defaultTotalItems;
        await this.loadDataset();
      }
    }
  }

  private async loadDataset() {

    if (!this.datasetUuid || this.loading) {
      return;
    }

    this.loading = true;

    try {
      const { page, itemsPerPage } = this.options;
      this.skip = ((page - 1) * itemsPerPage);
      const result = await DataSetService.getDatasetData(this.datasetUuid, {
        limit: itemsPerPage + 1,
        offset: this.skip,
        since: this.sinceBefore[0] ? this.sinceBefore[0] : undefined,
        before: this.sinceBefore[1] ? this.sinceBefore[1] : undefined,
        timeOrder: 'desc',
        includeTestBench: this.includeTestBench,
        includeStock: this.includeStock,
      });

      const items: any[] = result.results;

      if (items.length) {
        this.headers = result.fields.map((fieldName: string) => ({
          text: fieldName,
          value: fieldName,
          sortable: false,
        }));
        this.columns = result.fields.map((fieldName: string) => fieldName);
      }

      this.totalItems = Math.max(this.totalItems, ((page - 1) * itemsPerPage) + items.length);


      this.items = items;
    } finally {
      this.loading = false;
    }
  }

  private async onOptionsChanged(event: any) {
    this.options = event;
    await this.loadDataset();
  }

  @Watch('loading')
  private onLoadingChanged() {
    this.$emit('isLoading', this.loading);
  }

  private async getAllData(maxRows: number): Promise<any[]> {
    const result = await DataSetService.getDatasetData(this.datasetUuid, {
          limit: 30000,
          offset: 0,
          since: this.sinceBefore[0] ? this.sinceBefore[0] : undefined,
          before: this.sinceBefore[1] ? this.sinceBefore[1] : undefined,
          timeOrder: 'desc',
          includeTestBench: this.includeTestBench,
          includeStock: this.includeStock,
        });
    return result.results;

  }

  private async test(): Promise<any> {
    return new Promise((res) => {
      setTimeout(() => {
        res({
          success: true,
          data: [
            {device_id: 'ABC123', some_value_1: 'sfgegfewwgff', some_value_2: 24, some_value_3: 3432545325},
          ],
        });
      }, 1000);
    });
  }
}
